import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: 0,
}

export const mySourcesSlice = createSlice({
  name: 'mysources',
  initialState,
  reducers: {
    clearMySources: (state) => {
      state.value = []
    },
    updateMySources: (state, action) => {
      state.value = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { clearMySources, updateMySources} = mySourcesSlice.actions

export default mySourcesSlice.reducer